<h2>Add clients</h2>
<div>
  @if (unassignedClients().length) {
  <da-multi-select-client
    class="full-width"
    label="Filter by Client"
    placeholder="Pick client..."
    [list]="unassignedClients()"
    (selectingChange)="selectClients($event)"
  >
  </da-multi-select-client>
  } @else {
  <h3>Empty list</h3>
  }
</div>
<div class="buttons">
  <button mat-raised-button mat-dialog-close color="warn">Cancel</button>
  <button mat-raised-button [mat-dialog-close]="addingClients()" color="primary" [disabled]="!addingClients().length">Add</button>
</div>
